// extracted by mini-css-extract-plugin
export default {"wrapper":"LabelValue_wrapper__2O+Uw","heading":"LabelValue_heading__umToM","value":"LabelValue_value__nH2SA"};